import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { CheckIcon, XIcon } from 'lucide-react';
export function Audience() {
  const isFor = ['Mujeres de 65 años o más que sienten rigidez en manos, rodillas o espalda al despertar.', 'Personas que quieren reducir su dependencia de analgésicos comunes.', 'Abuelas que quieren tener la energía y movilidad necesaria para jugar con sus nietos.', 'Compradoras prácticas que buscan salud real sin gastar una fortuna en comida gourmet.'];
  const notFor = ['Personas que buscan una solución mágica o una cirugía rápida.', 'Quienes no están dispuestos a cambiar su marca de aceite de cocina por una opción saludable.', 'Quienes buscan una dieta de pérdida de peso extrema o para deportistas de alto rendimiento.'];
  return <div className="bg-white py-24 px-6" data-id="element-14">
      <AnimatedSection className="max-w-6xl mx-auto" data-id="element-15">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-16">
          {/* Para quién es */}
          <div className="bg-brand-lightGreen/30 p-8 md:p-10 rounded-3xl border border-brand-green/20" data-id="element-17">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-brand-green text-center" data-id="element-18">
              Para quién SÍ es
            </h3>
            <ul className="space-y-6" data-id="element-19">
              {isFor.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-20">
                  <div className="bg-brand-green/10 p-1 rounded-full mt-1 flex-shrink-0" data-id="element-21">
                    <CheckIcon className="w-5 h-5 text-brand-green" data-id="element-22" />
                  </div>
                  <span className="text-lg" data-id="element-23">{text}</span>
                </li>)}
            </ul>
          </div>

          {/* Para quién no es */}
          <div className="bg-red-50/50 p-8 md:p-10 rounded-3xl border border-red-100" data-id="element-24">
            <h3 className="text-2xl md:text-3xl font-bold mb-8 text-red-800 text-center" data-id="element-25">
              Para quién NO es
            </h3>
            <ul className="space-y-6" data-id="element-26">
              {notFor.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-27">
                  <div className="bg-red-100 p-1 rounded-full mt-1 flex-shrink-0" data-id="element-28">
                    <XIcon className="w-5 h-5 text-red-600" data-id="element-29" />
                  </div>
                  <span className="text-lg" data-id="element-30">{text}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </AnimatedSection>
    </div>;
}